// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ChatDetailsPanel.test.tsx
// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ChatMessage.test.tsx
import { useTranslation } from "react-i18next";

import { DocumentDownloadRow } from "../../../components/DocumentDownloadRow";

/**
 * Chat message attachments and the Details rail uploaded-files list.
 * Same row as context-pane reference documents (DocumentDownloadRow).
 *
 * Project reference lists stay on DownloadableReferenceRow in
 * CampaignDocsPanel — those rows own a type label and a version badge.
 */
export function FileAttachmentButton({
  url,
  name,
  testId = "chat-file-attachment",
  ariaLabel,
}: {
  url: string;
  name?: string;
  /** Override for per-file ids in the Details rail. */
  testId?: string;
  /** Override accessible name. */
  ariaLabel?: string;
}) {
  const { t } = useTranslation("ui");
  const label = name?.trim() ? name : t("download");

  return (
    <DocumentDownloadRow
      url={url}
      name={label}
      downloadAs={name ?? null}
      testId={testId}
      ariaLabel={ariaLabel ?? `Download attachment ${name ?? ""}`.trim()}
    />
  );
}
